/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Lpmaximumticketsize4Inputs */

const en_coinvestments_tracking_lpmaximumticketsize4 = /** @type {(inputs: Coinvestments_Tracking_Lpmaximumticketsize4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Max. Ticket Size" |
*
* @param {Coinvestments_Tracking_Lpmaximumticketsize4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_lpmaximumticketsize4 = /** @type {((inputs?: Coinvestments_Tracking_Lpmaximumticketsize4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Lpmaximumticketsize4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_lpmaximumticketsize4(inputs)
});
export { coinvestments_tracking_lpmaximumticketsize4 as "coInvestments_tracking_lpMaximumTicketSize" }